/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT ///
import { useEffect } from "react";
import { useState } from "react";
/// ACTIONS ///
import { updateLocalShopCounter } from "api/actions/shop_quote";
/// TYPES ///
import { IShopArea } from "api/types/shop_quote/area";
import { IShopCounter } from "api/types/shop_quote/counter";
import { IShopSlab } from "api/types/shop_quote/slab";
/// COMPONENTS ///
import UpdateArea from "components/quote/drawer/update_area";
/// FUNCTIONS ///
import { getShopAreaById } from "functions/sketch/get/area";
import { handleUpdateShopCounter } from "handler/shop_counter/update";
import { getFirstShopSlabInArea } from "functions/sketch/get/shop_slab";

interface Props {
  open: boolean,
  setOpen: (open: boolean) => void,
  counter: IShopCounter
}

export default function UpdateShopArea({ open, setOpen, counter }: Props) {
  const dispatch = useAppDispatch();
  const { areas } = useAppSelector(state => state.shop_quote);
  const { cut_shapes } = useAppSelector(state => state.shop_quote);
  const [area, setArea] = useState<IShopArea>({});
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    const area: IShopArea | null = getShopAreaById(areas, counter?.area);
    if (area) {
      setArea(area);
    }
  }, [areas, counter?.area]);

  const save = () => {
    if (area?.id > 0) {
      const slab: IShopSlab | null = getFirstShopSlabInArea(area);
      if (slab) {
        handleUpdateShopCounter(
          dispatch,
          { ...counter },
          { ...counter, area_uuid: area.uuid, area: area.id, drawing_color: area.number - 1 },
          cut_shapes.filter(shape => shape.counter_uuid === counter.uuid),
          slab.uuid,
          "Change Counter Area"
        );
      }
      setOpen(false);
    }
    else {
      setError(true);
    }
  }

  const update = (area_id: number) => {
    const area: IShopArea | null = getShopAreaById(areas, area_id);
    if (area) {
      setArea(area);
      dispatch(updateLocalShopCounter({ ...counter, area_uuid: area.uuid, area: area.id, drawing_color: area.number - 1 }));
      setError(false);
    }
  }

  const close = () => {
    setOpen(false);
  }

  return (
    <UpdateArea
      open={open}
      area_id={area?.id ?? 0}
      areas={areas}
      error={error}
      update={update}
      close={close}
      save={save} />
  );
}
